import { LazyLoad } from 'app/utils';

export const TransactionListPage = LazyLoad(
  () => import('./index'),
  (module) => module.TransactionListPage,
);
